<template lang="">
	<sf-modal-layout :title="getMessage_('MWCC000764')" :show="UploadFormDetail" :closeModal="closeDetail" size="L">
		<el-row :gutter="30">
			<el-col :span="12">
				<sf-group-wrapper :label="getMessage_('MWCC000330')" labelPosition="left" :gutter="10" :labelSpan="7">
					<el-row :gutter="10">
						<el-col>
							{{ UploadFormDetailValue.gqmsSeq }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
			<!-- <el-col :span="6">
				<sf-group-wrapper :label="getMessage_('MWCC000844')" labelPosition="left" :gutter="10" :labelSpan="7">
					<el-row :gutter="10">
						<el-col>
							{{ UploadFormDetailValue.category }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col> -->
			<!-- <el-col :span="7">
				<sf-group-wrapper :label="getMessage_('MWCC000845')" labelPosition="left" :gutter="10" :labelSpan="9">
					<el-row :gutter="10">
						<el-col>
							{{ UploadFormDetailValue.dtlCategory }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col> -->
			<el-col :span="12">
				<!-- 작성자 -->
				<sf-group-wrapper :label="getMessage_('MWCC000848')" labelPosition="left" :gutter="10" :labelSpan="8">
					<el-row :gutter="10">
						<el-col>
							{{ UploadFormDetailValue.regId }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 제목 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('MWCC000519')" labelPosition="left" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24">
							{{ UploadFormDetailValue.gqmsTitle }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 내용 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('MWCC000846')" labelPosition="left" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24" v-html="nl2br(UploadFormDetailValue.gqmsConts)"> </el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 이미지 영역 -->
			<el-col :span="12">
				<sf-group-wrapper :label="getMessage_('MWCC000846')" labelPosition="left" :gutter="10" :labelSpan="5">
					<el-image class="preViewImgSize" :src="UploadFormDetailValue.img1Url" :preview-src-list="UploadFormDetailValue.imgPreviewList">
					</el-image>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="12">
				<sf-group-wrapper :label="getMessage_('MWCC000846')" labelPosition="left" :gutter="10" :labelSpan="5">
					<el-image class="preViewImgSize" :src="UploadFormDetailValue.img2Url" :preview-src-list="UploadFormDetailValue.imgPreviewList">
					</el-image>
				</sf-group-wrapper>
			</el-col>
		</el-row>

		<!-- 파일 다운로드 link -->
		<!-- <el-row>
			<el-col :span="24">
				<sf-data-table ref="link-table" :columns="columns" :rows="rows" sortable="false"> </sf-data-table>
			</el-col>
		</el-row> -->
		<el-row>
			<sf-group-wrapper labelPosition="left" :label="getMessage_('QWCC000925')" :gutter="10" :labelSpan="5">
				<file-upload-list id="fileList" :propFileList="rtnFile" style="height: 100px; border: solid" ref="fileArea"></file-upload-list>
			</sf-group-wrapper>
		</el-row>
		<template v-slot:footer>
			<sf-button v-if="isButton_(scrId, 'CD')" line color="error" :onClick="deleteAction">{{ getMessage_('MWCC000107') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" :onClick="updateAction">{{ getMessage_('MWCC000233') }}</sf-button>
			<sf-button line :onClick="closeDetail">{{ getMessage_('QWCC001971') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/UploadForm/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: {
		FileUploadList
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		//파일 다운로드를 위해  파일명에 링크 이벤트 추가(columns와 rows)
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000924'), //파일명
					prop: 'fileName',
					minWidth: '50px',
					clickEvent: this.clickEvent,
					highlight: true,
					sortable: false
				}
			];
		},
		rows() {
			return this.UploadFormDetailValue.fileInfo;
		},
		rtnFile() {
			//console.log('test', this.UploadFormDetailValue.fileList);
			return this.UploadFormDetailValue.fileList;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('MWCC000554'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.delete() }] //삭제
			});
		},

		delete() {
			this.$sf_toggleLoading(true);
			this.delUploadForm_({ params: { ...this.UploadFormDetailValue } })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					// 2. 완료되면 목록 조회 진행
					this.getUploadFormList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
					this.closeDetail();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		updateAction() {
			//수정버튼 클릭시 flg값을 U로 하고 DegailValue의 데이터를 Modal쪽으로 넘긴다.
			//console.log('this.UploadFormDetailValue 값 확인, ', this.UploadFormDetailValue);
			this.defaultAssign_({ key: 'UploadFormModalValue', value: { flg: 'U', ...this.UploadFormDetailValue } });
			this.defaultAssign_({ key: 'UploadFormDetail', value: false });
			this.defaultAssign_({ key: 'UploadFormModal', value: true });
		},

		closeDetail() {
			this.closeDetail_();
		},

		nl2br(str) {
			return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
		},
		clickEvent(row) {
			//파일 아이디와 파일 SEQ로 진행
			this.fileDownload_({ fileId: row.fileId, fileSeq: row.fileSeq })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: 'File Download Successfully' });
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style>
span.caret-wrapper {
	display: none;
}
.preViewImgSize {
	width: 300px;
	height: 200px;
}
</style>
